import { Badge, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

const STATUSES = {
  opened: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Interface-Tertiary',
    label: 'tickets::list.statuses.opened',
  },
  closed: {
    icon: 'status active',
    color: 'Label-Fifth',
    bgColor: 'Background-Fifth',
    label: 'tickets::list.statuses.closed',
  },
  pending: {
    icon: 'time-clock',
    color: 'Label-GU-Primary',
    bgColor: 'Background-Fifth',
    label: 'tickets::list.statuses.pending',
  },
  working: {
    icon: 'time-clock',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'tickets::list.statuses.working',
  },
}

export const StatusBadge = ({ status = null, ...rest }) => {
  const currentStatus = STATUSES?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Badge
      noWrap
      {...rest}
      size={'xs'}
      variant={'Body-10'}
      bgColor={bgColor}
      color={color}
      startIcon={
        <Icon
          color={color}
          name={icon}
          width={16}
        />
      }
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
